import store from '@/store/index.js'
async function copyToClipboard(copyText) {
    await navigator.clipboard.writeText(copyText);
    // store.dispatch('setSnackMessage', {message: `скопійовано у буфер: ${copyText}`, icon: 'mdi-content-copy'})
    store.commit('setSnackMessage', {message: `скопійовано у буфер: ${copyText}`, color: 'black', icon: 'mdi-content-copy'})
}

export {copyToClipboard}
